import {createSlice} from '@reduxjs/toolkit'

const initialAuthState={
  isAuthenticated: false
}

export const authSlice = createSlice({
  name: 'authentication',
  initialState: initialAuthState,
  reducers:{
    login(state){
      state.isAuthenticated = true;
    },
    logout(state){
      state.isAuthenticated = false;
    }
  }
})